export default function TbLayoutNavbarInactive() {
	return (
		<svg
			aria-hidden="true"
			role="presentation"
			stroke="currentColor"
			fill="none"
			strokeWidth="2"
			viewBox="0 0 24 24"
			strokeLinecap="round"
			strokeLinejoin="round"
			className="scale-[1.1]"
			height="1em"
			width="1em"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z"></path>
			<path d="M4 9h1"></path>
			<path d="M19 9h1"></path>
			<path d="M9 9h1"></path>
			<path d="M14 9h1"></path>
		</svg>
	);
}